<h1 mat-dialog-title
    class="draggable-dialogue-header center-text"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    {{this.Title}}
</h1>

<form [formGroup]="NgFormGroup">
    <div class="margin-10" mat-dialog-content>
        <p [innerHtml]="Message | safe: 'html'"></p>
    </div>

    <div class="margin-10">
        @if (!HideRequestAssistance) {
        <mat-checkbox class="margin-10" (click)="toggleNotifyDevs()">Request assistance</mat-checkbox>
        }
        @if (NotifyDevs) {
        <div>
            <div>
                <textarea class="description-textarea"
                          formControlName="tryingToDo"
                          rows="5"
                          maxlength="10000"
                          aria-label="Please enter a description"
                          placeholder="{{Placeholder}}"></textarea>
            </div>
            @if (UserEmail) {
            <mat-checkbox class="margin-10"
                          title="Send copy of error report email to me"
                          (click)="toggleCCtoUser()">
                Send CC to {{UserEmail}}
            </mat-checkbox>
            }
        </div>
        }
    </div>
    @if (ShowTechnicalDetails) {
    <div class="margin-10" [@.disabled]="disableAnimation">
        <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Technical Details
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="technical-info">
                {{this.TechnicalInfo}}
                @if (CorrelationId) {
                <div>
                    <br />
                    <span>Correlation ID</span>
                    <br />
                    <span class="correlation-id-span">
                        <span class="flex-grow-1"></span>
                        <button mat-icon-button class="copy-button" (click)="CopyToClipboard()" title="Copy to Clipboard">
                            <mat-icon id="copybutton">content_copy</mat-icon>
                        </button>
                        &nbsp;
                        <span class="correlation-id">{{CorrelationId}}</span>
                    </span>
                </div>
                }
            </div>
        </mat-expansion-panel>
    </div>
    }

    <div class="center-button" mat-dialog-actions>
        @if (NotifyDevs) {
        <button mat-raised-button
                [disabled]="SendDisabled"
                color="accent"
                [attr.aria-label]="SendCaption"
                (click)="SendErrorReport()">{{SendCaption}}</button>
        }
        <button mat-raised-button
                color="primary"
                (click)="reloadPage()"
                aria-label="Close"
                mat-dialog-close class="close-btn">Close</button>
    </div>
    <br />
    <div>
        {{EmailStatus}}
    </div>
</form>
